import { useState } from 'react';
import { MaterialsPickerModal } from '../../materials/MaterialsPickerModal';

interface SoundLogoSlotProps {
  sceneId: string;
  materialId?: string;
  /** 選択中サウンドロゴの表示名 (スクリプト相当)。SceneItem 側で解決して渡す。 */
  displayName?: string | null;
  onSelect: (sceneId: string, materialId: string) => void;
  onClear: (sceneId: string) => void;
}

/**
 * シーンのサウンドロゴ枠。選択済みサウンドロゴのスクリプト名を表示し、素材ピッカー
 * (音声・サウンドロゴ優先) から選び直せる。ナレーション枠と排他で、
 * audio_track_type='sound_logo' のときに表示される。再生・尺・DLは最下部の結果エリア側。
 */
export function SoundLogoSlot({ sceneId, materialId, displayName, onSelect, onClear }: SoundLogoSlotProps) {
  const [pickerOpen, setPickerOpen] = useState(false);

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 0', flexWrap: 'wrap' }}>
      {materialId ? (
        <>
          <span style={{ flex: '1 1 auto', minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '0.85rem', color: 'rgba(245, 241, 230, 0.9)' }}>
            {displayName || 'サウンドロゴ'}
          </span>
          <button
            type="button"
            onClick={() => setPickerOpen(true)}
            style={{ fontSize: '0.8rem', background: 'transparent', border: 'none', padding: '2px 4px', color: 'rgba(245, 241, 230, 0.7)', cursor: 'pointer' }}
          >
            変更
          </button>
          <button
            type="button"
            onClick={() => onClear(sceneId)}
            title="サウンドロゴを解除"
            aria-label="サウンドロゴを解除"
            style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '22px', height: '22px', fontSize: '1rem', lineHeight: 1, border: 'none', background: 'transparent', color: 'rgba(245, 241, 230, 0.6)', cursor: 'pointer' }}
          >
            ×
          </button>
        </>
      ) : (
        <button
          type="button"
          onClick={() => setPickerOpen(true)}
          style={{ fontSize: '0.85rem', background: 'transparent', border: '1px dashed rgba(245, 241, 230, 0.3)', borderRadius: '6px', padding: '6px 12px', color: 'rgba(245, 241, 230, 0.8)', cursor: 'pointer' }}
        >
          ＋ サウンドロゴを選択
        </button>
      )}

      {pickerOpen && (
        <MaterialsPickerModal
          title="サウンドロゴにする音声を選択"
          fileTypes={['audio']}
          soundLogoFirst
          onSelect={(_url, pickedId) => {
            setPickerOpen(false);
            if (pickedId) onSelect(sceneId, pickedId);
          }}
          onClose={() => setPickerOpen(false)}
        />
      )}
    </div>
  );
}
